import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../redux/store';
import { BombSplatDisplay } from './bombSplatDisplay';
function playerBombSplatsEqualityFn(bombSplats1, bombSplats2) {
    if (bombSplats1 && bombSplats2) {
        const bombSplatIds1 = bombSplats1.map((bombSplat) => bombSplat.id);
        const bombSplatIds2 = bombSplats2.map((bombSplat) => bombSplat.id);
        return shallowEqual(bombSplatIds1, bombSplatIds2);
    }
    return bombSplats1 === bombSplats2;
}
export const PlayerBombSplatsContainer = ({ seatIndex }) => {
    const bombSplats = useAppSelector((state) => state.bombs.bombSplats[seatIndex], playerBombSplatsEqualityFn);
    const baseBombScaleFactor = useAppSelector((state) => state.gameDimensions.baseBombScaleFactor);
    if (!bombSplats || baseBombScaleFactor === undefined) {
        return null;
    }
    return (_jsx(Container, { interactiveChildren: false, children: bombSplats.map((bombSplat) => (_jsx(BombSplatDisplay, { bombSplat: bombSplat, baseBombScaleFactor: baseBombScaleFactor }, bombSplat.id))) }));
};
